import axios from "axios";

/* ===============================
   BASE URL
=============================== */

const BASE_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:8080"
    : "https://isabistudio.com";

/* ===============================
   AXIOS INSTANCE
=============================== */

const api = axios.create({
  baseURL: BASE_URL
});

/* ===============================
   AUTH TOKEN
=============================== */

api.interceptors.request.use((config) => {

  const token =
    localStorage.getItem("token");

  if (token) {

    config.headers.Authorization =
      `Bearer ${token}`;

  }

  return config;

});
/* ===============================
   RESPONSE INTERCEPTOR
=============================== */

api.interceptors.response.use(

  (response) => response,

  (error) => {

    /* ===============================
       TOKEN EXPIRED
    =============================== */

    if (
      error?.response?.status === 401
    ) {

      localStorage.removeItem("token");
      localStorage.removeItem("role");

      window.location.href =
        "/login";

    }

    return Promise.reject(error);

  }

);

export default api;